"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleRegistrationNumberWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var operators_1 = require("rxjs/operators");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var services_1 = require("@falcon/services");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var imageResizeHelper_1 = require("../../helpers/imageResizeHelper");
var VehicleRegistrationNumberWidget = /** @class */ (function (_super) {
    __extends(VehicleRegistrationNumberWidget, _super);
    function VehicleRegistrationNumberWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyPress = function (event) {
            if (event.key === "Enter") {
                // @ts-ignore
                document.getElementById("input-label").click();
            }
        };
        _this.handleChange = function (event) {
            event.preventDefault();
            _this.validate(event);
            var vrn = event.target.value.trim().toUpperCase();
            _this.setState({ vrn: vrn });
            _this.props.onStateChange(_this.props.question.interactionField, vrn);
            _this.executeNativeEvent(event);
            _this.changelogRecorder.recordQuestion("change", _this.props);
            _this.setState({
                registrationNumberDisabled: !services_1.VEHICLE_REG_NUMBER_REGEX.test(vrn)
            });
        };
        _this.getFile = function (event) {
            var file = event.target.files[0];
            if (file) {
                var reader_1 = new FileReader;
                reader_1.readAsDataURL(file);
                reader_1.onload = function () {
                    imageResizeHelper_1.default.checkAndResize(file, reader_1.result).then(function (contents) {
                        if (typeof contents !== "string") {
                            return;
                        }
                        _this.setState({
                            file: {
                                base64: contents
                            }
                        });
                        _this.handleResolve(contents);
                    });
                };
            }
        };
        _this.handleResolve = function (base64) {
            _this.toggleOverlay(true);
            _this.falconConvenienceApiService.getRegistrationNumber(base64)
                .pipe((0, operators_1.finalize)(function () {
                _this.toggleOverlay(false);
                _this.props.engine.validate();
            }))
                .subscribe(function (response) {
                var _a, _b, _c;
                if (response) {
                    if (response.registrationNumber) {
                        var vrn = response.registrationNumber;
                        _this.setState({ vrn: vrn });
                        _this.props.onStateChange(_this.props.question.interactionField, vrn);
                        _this.validateInternal(vrn);
                        _this.props.engine.setJourneyState((_a = {
                                ocrErrorCode: null
                            },
                            _a["hidePageValidationErrorMessage"] = Boolean(response.registrationNumber),
                            _a));
                        _this.setState({ registrationNumberDisabled: !services_1.VEHICLE_REG_NUMBER_REGEX.test(vrn) });
                    }
                    else if (response.statusCode) {
                        _this.props.engine.setJourneyState((_b = {
                                ocrErrorCode: response.statusCode
                            },
                            _b["hidePageValidationErrorMessage"] = Boolean(response.registrationNumber),
                            _b));
                    }
                    else {
                        _this.props.engine.setJourneyState((_c = {
                                ocrErrorCode: "error"
                            },
                            _c["hidePageValidationErrorMessage"] = Boolean(response.registrationNumber),
                            _c));
                    }
                }
            }, function () {
                var _a;
                _this.props.engine.setJourneyState((_a = {
                        ocrErrorCode: "serviceError"
                    },
                    _a["hidePageValidationErrorMessage"] = false,
                    _a));
            });
        };
        _this.toggleOverlay = function (showOverlay) {
            _this.setState({
                showOverlay: showOverlay
            });
        };
        _this.inputLabel = document.getElementById("input-label");
        if (_this.inputLabel) {
            _this.inputLabel.addEventListener("keydown", _this.handleKeyPress.bind(_this));
        }
        _this.state = {
            vrn: _this.bindFromField(_this.props.question.interactionField) || "",
            file: null,
            showOverlay: false,
            registrationNumberDisabled: _this.isRegistrationNumberDisabled()
        };
        _this.handleResolve = _this.handleResolve.bind(_this);
        _this.getFile = _this.getFile.bind(_this);
        _this.validate = _this.validate.bind(_this);
        return _this;
    }
    VehicleRegistrationNumberWidget.prototype.renderInputField = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "row w-100 m-0 vrn-widget", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "registrationNumber", className: "mr-2", children: "What\u2019s your car registration number?" }), (0, jsx_runtime_1.jsxs)("span", { className: "font-weight-light mb-3", children: ["Or if you prefer, ", (0, jsx_runtime_1.jsx)("label", { id: "input-label", className: "d-inline simple-link", htmlFor: "vrn-widget-upload-input", tabIndex: 0, onKeyDown: this.handleKeyPress, children: "upload a photo of your car's number plate" }), (0, jsx_runtime_1.jsx)("input", { type: "file", id: "vrn-widget-upload-input", className: "vrn-widget-upload-input", onChange: this.getFile })] }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsxs)("div", { className: "col-md-7 d-flex p-0 vrn-text-box", children: [(0, jsx_runtime_1.jsx)("div", { className: "vrn-text-box__country-code-wrapper", children: (0, jsx_runtime_1.jsx)("span", { className: "vrn-text-box__country-code", children: "GB" }) }), (0, jsx_runtime_1.jsx)("input", { onInput: this.handleChange, onBlur: function (event) { return _this.validate(event); }, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, value: this.state.vrn, type: "text", id: "registrationNumber", maxLength: 7, className: "form-control vrn-input-field ".concat(this.getInputValidationClass()), "aria-label": this.props.question.label })] }), (0, jsx_runtime_1.jsx)("div", { className: "col-md-5 pr-0 pl-7 pl-md-3 pt-3 pt-md-0 mobile-button-position", children: (0, jsx_runtime_1.jsx)("button", { type: "submit", disabled: this.state.registrationNumberDisabled, className: "btn btn-default btn-primary btn-next float-right m-0-desktop m-10-mobile", children: "Find my car" }) })] }), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.showOverlay })] }));
    };
    VehicleRegistrationNumberWidget.prototype.validate = function (event) {
        this.validateInternal(event.target.value);
    };
    ;
    VehicleRegistrationNumberWidget.prototype.isRegistrationNumberDisabled = function () {
        var _a, _b, _c;
        return !(((_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.process) === services_1.INTERACTION_PROCESS_NB && ((_c = (_b = this.props.interaction) === null || _b === void 0 ? void 0 : _b.vehicles[0]) === null || _c === void 0 ? void 0 : _c.registrationNumber));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], VehicleRegistrationNumberWidget.prototype, "falconConvenienceApiService", void 0);
    return VehicleRegistrationNumberWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.VehicleRegistrationNumberWidget = VehicleRegistrationNumberWidget;
//# sourceMappingURL=VehicleRegistrationNumberWidget.js.map